export default __webpack_public_path__ + "static/media/jeans.12bfa0ad.jpg";